export const RiskVariant = {
    WithoutPOV: 1,
    WithoutHAV: 5,
    Allrisk: 6,
    AccidentHAV: 7,
    Theft: 8,
    Package: 30,
    AllriskPlusGAP: 49,
    WithoutGlassInsurance: 200,
    Glass10000: 210,
    Glass15000: 215,
    Glass20000: 220,
    POV35: 2,
    POV50: 3,
    POV100: 4,
    POV150: 20,
    SpolPercentage0To5: 100,
    SpolPercentage5: 101,
    SpolPercentage10: 102,
    SpolPercentageFrom10: 103,
    AddonWarranty: 231,
    AddonGAP: 232,
    AddonAssistance: 233,
    Household: 234,
    Realty: 235,
    HouseholdAndRealty: 236,
    MiniRange: 237,
    MaxiRange: 238,
    PropertyWithoutLiability: 239,
    PropertySpol_0: 250,
    PropertySpol_1000: 251,
    PropertySpol_3000: 252,
    PropertySpol_5000: 253,
    PropertySpol_10000: 254,
    PropertySpol_30000: 255,
    IgnoreRange: 263,
    ZakladniAsistence: 264,
    StredniAsistence: 265,
    VyssiAsistence: 266,
    TravelRangeBasic: 268, //základní rozsah
    TravelRangeMiddle: 269, //střední rozsah
    TravelRangeHighest: 270, //nejvyšší rozsah
    TravelRangeAll: 271, //bez rozlišení rozsahu
    AddonLegalProtection: 267,
    RespectAssistance: 272,
    DirectLiquidationYes: 273,
    DirectLiquidationNo: 274,
    OdcizeniNo: 280,
    OdcizeniYes: 281,
    ZverNo: 291,
    ZverYes: 292,
    ResponsibilityRealestate_Without: 301,
} as const;

export type RiskVariant = typeof RiskVariant[keyof typeof RiskVariant];